import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SEO = ({ title, description, keywords, ogImage, twitterImage, canonicalUrl }) => {
  const location = useLocation();
  
  useEffect(() => {
    // Get the current path
    const currentPath = location.pathname;
    
    // Set page-specific title based on the current path
    if (currentPath === '/') {
      // Home page
      document.title = "Abhishek Bhalerao | Full Stack Developer & Robotics Engineer";
    } else if (currentPath === '/projects') {
      // Projects page
      document.title = "Projects | Abhishek Bhalerao - Full Stack Developer & Robotics Engineer";
    } else if (currentPath === '/about') {
      // About page
      document.title = "About | Abhishek Bhalerao - Full Stack Developer & Robotics Engineer";
    } else if (currentPath === '/contact') {
      // Contact page
      document.title = "Contact | Abhishek Bhalerao - Full Stack Developer & Robotics Engineer";
    } else if (currentPath.startsWith('/projects/')) {
      // Individual project page
      const projectId = currentPath.split('/').pop();
      document.title = `${projectId.charAt(0).toUpperCase() + projectId.slice(1).replace(/-/g, ' ')} | Abhishek Bhalerao`;
    } else {
      // Fallback for any other pages
      document.title = title || "Abhishek Bhalerao | Portfolio";
    }
    
    // Update meta tags
    const metaTags = {
      'description': description,
      'keywords': keywords,
      'og:title': document.title, // Use the same title we just set
      'og:description': description,
      'og:type': 'website',
      'og:url': canonicalUrl,
      'og:image': ogImage,
      'twitter:card': 'summary_large_image',
      'twitter:title': document.title, // Use the same title we just set
      'twitter:description': description,
      'twitter:image': twitterImage,
      'author': 'Abhishek Bhalerao'
    };
    
    // Update or create meta tags
    Object.entries(metaTags).forEach(([name, content]) => {
      if (!content) return;
      
      // Handle Open Graph tags differently
      if (name.startsWith('og:')) {
        const element = document.querySelector(`meta[property="${name}"]`) || 
                        document.createElement('meta');
        element.setAttribute('property', name);
        element.setAttribute('content', content);
        if (!element.parentNode) document.head.appendChild(element);
      } else {
        const element = document.querySelector(`meta[name="${name}"]`) || 
                        document.createElement('meta');
        element.setAttribute('name', name);
        element.setAttribute('content', content);
        if (!element.parentNode) document.head.appendChild(element);
      }
    });
    
    // Update canonical URL
    let canonicalElement = document.querySelector('link[rel="canonical"]');
    if (!canonicalElement) {
      canonicalElement = document.createElement('link');
      canonicalElement.setAttribute('rel', 'canonical');
      document.head.appendChild(canonicalElement);
    }
    canonicalElement.setAttribute('href', canonicalUrl);
    
  }, [title, description, keywords, ogImage, twitterImage, canonicalUrl, location.pathname]);
  
  return null; // This component doesn't render anything
};

export default SEO;






